import React from 'react';

function Intro() {
    return (
        <div id="intro">
            <p>
                The nation’s partisan divisions have{' '}
                <a
                    href="https://www.people-press.org/2019/10/10/partisan-antipathy-more-intense-more-personal/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    deepened and grown more personal
                </a>{' '}
                in recent years. And no recent president, from his earliest days
                in office, has evoked such strong feelings – both positive and
                negative – as Donald Trump.
            </p>
            <p>
                The intensity of sentiment has made it difficult for many
                Americans to discuss their opinions of Trump, especially in a
                social setting where others hold differing views.
            </p>
            <p>
                How would you feel discussing Trump with a group of people who
                have opposing views from your own? See how your views compare
                with the opinions of Americans in a{' '}
                <a
                    href="https://www.people-press.org/2019/06/19/public-highly-critical-of-state-of-political-discourse-in-the-u-s/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Pew Research Center survey
                </a>{' '}
                conducted earlier this year.
            </p>
            <div className="question">
                <p>Put yourself in this scenario:</p>
            </div>
            <p>
                A friend has invited you to a small dinner with people you have
                never met before. The conversation is moving along and people at
                the table begin talking about Trump. You realize that everyone
                at the table is expressing a view of the president that you
                don’t agree with. In fact, you hold the opposite view.
            </p>
        </div>
    );
}

export default Intro;
